import React from 'react'

const LoadingResults = () => {
  return (
    <span className="loading-results">
      <span>&bull;</span>
      <span>&bull;</span>
      <span>&bull;</span>
    </span>
  )
}

export default LoadingResults
